import _defineProperty from "/app/node_modules/.pnpm/next@13.4.17_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { delay, takeLatest, takeEvery, put } from 'redux-saga/effects';
import { select, call } from 'typed-redux-saga';
import { getBrowserAttributes } from 'libs/utils/threeDS2';
import { transformCheckoutDto } from 'data/transformers/checkout';
import { transformPaymentAuthAction } from 'data/transformers/payment';
import { transformCheckoutConfigurationDto } from 'data/transformers/checkout-configuration';
import { actions as shippingContactActions } from 'state/shipping-contact/slice';
import { DebitStatus } from 'constants/payment';
import * as api from 'data/api';
import { ResponseCode } from 'data/api/response-codes';
import { PAYMENT_POLL_DELAY, MAX_PAYMENT_POLL_ATTEMPT_COUNT } from './constants';
import * as checkoutSelectors from './selectors';
import * as paymentSelectors from './payment/selectors';
import * as statelessActions from './actions';
import * as transformers from './transformers';
import { actions } from './slice';
import { actions as paymentActions } from './payment';
export function* getCheckoutData(_ref) {
  let {
    payload: {
      transactionId
    }
  } = _ref;
  if (!transactionId) return;
  const checkoutResponse = yield* call(api.getCheckoutData, transactionId);

  if ('errors' in checkoutResponse) {
    yield put(actions.getCheckoutDataFailure());
    return;
  }

  const checkout = transformCheckoutDto(checkoutResponse.checkout);
  yield put(actions.getCheckoutDataSuccess({
    checkout
  }));
}
export function* updateCheckoutData(_ref2) {
  let {
    payload: {
      transactionId,
      updatedCheckoutData
    }
  } = _ref2;
  if (!transactionId) return;
  const checkoutResponse = yield* call(api.updateCheckoutData, transactionId, updatedCheckoutData || null);

  if ('errors' in checkoutResponse) {
    yield put(checkoutResponse.code === ResponseCode.PaymentAlreadyProcessed ? statelessActions.getEscrowPaymentDataRequest({
      transactionId
    }) : actions.updateCheckoutDataFailure());
    return;
  }

  const checkout = transformCheckoutDto(checkoutResponse.checkout);
  yield put(actions.updateCheckoutDataSuccess({
    checkout
  }));
}
export function* handleTwoFactorVerificationError(twoFactorVerificationDto) {
  if (!twoFactorVerificationDto) return;
  const twoFactorVerificationPayload = transformers.transformTwoFactorVerification(twoFactorVerificationDto);
  yield put(actions.setTwoFactorVerification(twoFactorVerificationPayload));
}
export function* handlePaymentResponseError(response) {
  var _response$errors$;

  if (!response) return;

  switch (response.code) {
    case ResponseCode.User2FAConfirmation:
      yield* call(handleTwoFactorVerificationError, response.payload);
      break;

    case ResponseCode.CreditCardExpired:
      yield put(paymentActions.setIsCardExpired({
        isExpired: true
      }));
      break;

    case ResponseCode.KYCError:
      yield put(actions.setIsKycConfirmationNeeded({
        isNeeded: true
      }));
      break;

    case ResponseCode.CheckoutChecksumMismatchError:
      yield put(actions.setHasChecksumError({
        hasChecksumError: true
      }));
      break;

    case ResponseCode.ShippingDiscountAlreadyUsed:
      yield put(actions.setHasShippingDiscountError({
        hasShippingDiscountError: true
      }));
      break;

    default:
      yield put(actions.setPaymentError({
        error: {
          message: (_response$errors$ = response.errors[0]) === null || _response$errors$ === void 0 ? void 0 : _response$errors$.value
        }
      }));
      break;
  }
}
export function* cleanupAfterPaymentFailure() {
  yield put(actions.setIsPaymentProcessing({
    isPaymentProcessing: false
  }));
  yield put(actions.clearPaymentAuthAction());
  yield put(actions.clearBlikAuth());
  const transactionId = yield* select(checkoutSelectors.getTransactionId);
  if (!transactionId) return;
  yield put(actions.updateCheckoutDataRequest({
    transactionId
  }));
}
export function* fetchConfiguration() {
  const response = yield* call(api.getCheckoutConfiguration);

  if ('errors' in response) {
    yield put(actions.fetchConfigurationFailure());
  } else {
    yield put(actions.fetchConfigurationSuccess({
      configuration: transformCheckoutConfigurationDto(response.checkout_configuration)
    }));
  }
}
export function* handlePaymentInitiationResponse(_ref3) {
  let {
    payload: {
      response
    }
  } = _ref3;

  if ('errors' in response) {
    yield call(handlePaymentResponseError, response);
    yield call(cleanupAfterPaymentFailure);
    return;
  }

  const {
    debit_status,
    pay_in_redirect_url,
    authentication_action,
    user_msg_thread_id
  } = response;

  if (debit_status === DebitStatus.Failed) {
    yield put(actions.setPaymentError({
      error: {
        message: ''
      }
    }));
    yield call(cleanupAfterPaymentFailure);
    return;
  }

  if (authentication_action) {
    yield put(actions.setPaymentAuthAction({
      paymentAuthAction: transformPaymentAuthAction(authentication_action)
    }));
    return;
  }

  yield put(actions.clearPaymentAuthAction());
  yield put(actions.setPayment({
    status: debit_status,
    conversationId: user_msg_thread_id,
    payInRedirectUrl: pay_in_redirect_url,
    authenticationAction: authentication_action && transformPaymentAuthAction(authentication_action)
  }));
}
export function* initiatePayment() {
  yield put(actions.removeFieldsErrors());
  yield put(actions.setIsPaymentProcessing({
    isPaymentProcessing: true
  }));
  const blikCode = yield* select(checkoutSelectors.getBlikPaymentCode);
  const transactionId = yield* select(checkoutSelectors.getTransactionId);
  const transactionChecksum = yield* select(checkoutSelectors.getTransactionChecksum);
  const isCardSingleUseOverriden = yield* select(paymentSelectors.getIsCardSingleUseOverriden);
  if (!transactionId) return;
  const response = yield* call(api.initiateEscrowPayment, transactionId, _objectSpread(_objectSpread({
    transactionChecksum,
    browserAttributes: getBrowserAttributes()
  }, !!blikCode && {
    blikCode
  }), isCardSingleUseOverriden && {
    isSingleUse: false
  }));
  yield put(statelessActions.handlePaymentInitiationResponse({
    response
  }));
}
export function* getPaymentData(_ref4) {
  let {
    payload
  } = _ref4;
  yield put(actions.setIsPaymentProcessing({
    isPaymentProcessing: true
  }));
  const response = yield* call(api.getEscrowPayment, payload.transactionId);
  yield put(statelessActions.handlePaymentInitiationResponse({
    response
  }));
}
export function* updatePaymentData(_ref5) {
  let {
    payload
  } = _ref5;
  yield put(actions.setIsPaymentProcessing({
    isPaymentProcessing: true
  }));
  const transactionId = yield* select(checkoutSelectors.getTransactionId);
  if (!transactionId) return;
  const response = yield* call(api.updateEscrowPaymentData, transactionId, {
    paymentData: {
      data: payload.paymentData,
      details: payload.paymentDetails
    }
  });
  yield put(statelessActions.handlePaymentInitiationResponse({
    response
  }));
}
export function* handlePendingPayment(_ref6) {
  let {
    payload: {
      transactionId,
      pollAttemptCount
    }
  } = _ref6;
  yield put(actions.setIsPaymentProcessing({
    isPaymentProcessing: true
  }));
  yield delay(PAYMENT_POLL_DELAY);
  const response = yield* call(api.getEscrowPayment, transactionId);

  if ('errors' in response) {
    yield put(actions.setPaymentError({
      error: {
        message: ''
      }
    }));
    yield put(actions.setIsPaymentProcessing({
      isPaymentProcessing: false
    }));
    return;
  }

  const {
    debit_status,
    user_msg_thread_id
  } = response;
  const isPending = debit_status === DebitStatus.Pending;
  const shouldPoll = isPending && pollAttemptCount < MAX_PAYMENT_POLL_ATTEMPT_COUNT;

  if (shouldPoll) {
    yield put(statelessActions.handlePendingPayment({
      transactionId,
      pollAttemptCount: pollAttemptCount + 1
    }));
    return;
  }

  if (isPending) {
    yield put(actions.setIsPaymentProcessingTakesTooLong({
      isPaymentProcessingTakesTooLong: true
    }));
  }

  yield put(actions.setPayment({
    status: debit_status,
    conversationId: user_msg_thread_id,
    payInRedirectUrl: null
  }));
  yield put(actions.setIsPaymentProcessing({
    isPaymentProcessing: false
  }));
}
export function* handlePaymentRedirectResult(_ref7) {
  let {
    payload: {
      transactionId
    }
  } = _ref7;
  yield put(actions.setIsPaymentProcessing({
    isPaymentProcessing: true
  }));
  yield put(actions.getCheckoutDataRequest({
    transactionId
  }));
  const response = yield* call(api.getEscrowPayment, transactionId);

  if ('errors' in response) {
    yield put(actions.setPaymentError({
      error: {
        message: ''
      }
    }));
    yield put(actions.setIsPaymentProcessing({
      isPaymentProcessing: false
    }));
    return;
  }

  const {
    debit_status,
    user_msg_thread_id
  } = response;

  if (debit_status === DebitStatus.Pending) {
    yield put(statelessActions.handlePendingPayment({
      transactionId,
      pollAttemptCount: 0
    }));
    return;
  }

  if (debit_status === DebitStatus.Failed) {
    yield put(actions.setIsPaymentFailedAfterRedirect({
      isPaymentFailedAfterRedirect: true
    }));
  }

  yield put(actions.setPayment({
    status: debit_status,
    conversationId: user_msg_thread_id,
    payInRedirectUrl: null
  }));
  yield put(actions.setIsPaymentProcessing({
    isPaymentProcessing: false
  }));
}
export default function* saga() {
  yield takeLatest(statelessActions.fetchConfigurationRequest, fetchConfiguration);
  yield takeLatest([statelessActions.initiateEscrowPaymentRequest, actions.confirmBlikAuth], initiatePayment);
  yield takeLatest(statelessActions.getEscrowPaymentDataRequest, getPaymentData);
  yield takeLatest(statelessActions.updateEscrowPaymentDataRequest, updatePaymentData);
  yield takeEvery(actions.getCheckoutDataRequest, getCheckoutData);
  yield takeEvery([actions.updateCheckoutDataRequest, shippingContactActions.saveTransactionShippingContactSuccess, shippingContactActions.deleteTransactionShippingContactSuccess], updateCheckoutData);
  yield takeLatest(statelessActions.handlePaymentInitiationResponse, handlePaymentInitiationResponse);
  yield takeLatest(statelessActions.handlePendingPayment, handlePendingPayment);
  yield takeLatest(statelessActions.handlePaymentRedirectResult, handlePaymentRedirectResult);
}